package haxe.ui.util.filters;

class Filter {
    public function new() {
    }
}